interface INavigationItem {
    action: IActionType;
    title: string;
}
interface INavigationCategory {
    order: number;
    category: string;
    items: INavigationItem[]
}

class SiteElementNavigation
    extends QueryElement<HTMLElement> {

    constructor(card: SiteCard, element: HTMLElement) {
        super(element, false);

        let path = this.getAttr('data-path');
        let value = card.Model.get((path && SiteModel.split(path)) || []) as INavigationCategory[];

        // Check if null or undefined
        if (value != null) {
            for (let category of value.sort((a, b) => a.order - b.order)) {
                let container = QueryElement.QueryElement("div");
                let count = 0;
                for (let item of category.items) {

                    // If action isn't defined, continue
                    if (!item.action)
                        continue;

                    count++;
                    container.append(new SiteActionButton(card, {
                        action: item.action,
                        title: item.title,
                        isFocusable: true
                    }));
                }

                if (count > 0) {
                    QueryElement.QueryElement("div")
                        .addClass("heading")
                        .append(QueryElement.QueryElement("h3")
                            .setHtml(category.category))
                        .appendTo(this);

                    this.append(container);
                }
            }
        }
    }
}